import type { HarnessToolDefinition } from "../types.js";

type ToolResult = Awaited<ReturnType<HarnessToolDefinition["handler"]>>;

/**
 * In-process MCP server handle for the PTY harness.
 *
 * S1 materializes tools as a directly-invokable in-process handle: callers
 * resolve a tool by name and invoke its handler.  Wiring these tools to the
 * `claude` CLI over a live stdio MCP transport (via `--mcp-config`) is
 * deferred to S4 — the spawn layer already threads `mcpConfigPath` through
 * for that purpose.
 */
export class PtyMcpServer {
  constructor(
    public readonly name: string,
    public readonly tools: HarnessToolDefinition[],
  ) {}

  getTool(name: string): HarnessToolDefinition | undefined {
    return this.tools.find((tool) => tool.name === name);
  }

  invokeTool(name: string, input: unknown): Promise<ToolResult> {
    const tool = this.getTool(name);
    if (!tool) return Promise.reject(new Error(`Unknown tool: ${name}`));
    return tool.handler(input);
  }
}
